// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Switch":"Switch_24q26_v13-0-0","Switch__Flat":"Switch__Flat_kNskP_v13-0-0","Switch__Tiny":"Switch__Tiny_nsOLn_v13-0-0"};
    if(module.hot) {
      // 1588357787764
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  